import { Injectable } from '@angular/core';
import { AppConfigService } from './app-config.service';

/**
 * Identificadores fictícios gravados no basePath de cada api.base.service.ts gerado.
 * O script generate-openapi.js substitui 'http://localhost' por esses valores durante
 * a geração dos stubs, permitindo que este serviço identifique o microsserviço de destino
 * apenas pelo início da URL, sem precisar mapear cada prefixo de path individualmente.
 */
export type ServiceApiKey =
  | 'https://alert-service'
  | 'https://bulk-load-service'
  | 'https://configuration-service'
  | 'https://data-ingestion'
  | 'https://wallet-service';

@Injectable({
  providedIn: 'root',
})
export class BaseUrlInterceptorService {
  private readonly serviceKeys: ServiceApiKey[];
  private readonly baseUrlByKey: Record<ServiceApiKey, string>;

  constructor(private readonly appConfigService: AppConfigService) {
    this.baseUrlByKey = {
      'https://alert-service': this.appConfigService.config.alertServiceBaseUrl,
      'https://bulk-load-service': this.appConfigService.config.bulkLoadServiceBaseUrl,
      'https://configuration-service': this.appConfigService.config.configurationServiceBaseUrl,
      'https://data-ingestion': this.appConfigService.config.dataIngestionServiceBaseUrl,
      'https://wallet-service': this.appConfigService.config.walletServiceBaseUrl,
    };
    this.serviceKeys = Object.keys(this.baseUrlByKey) as ServiceApiKey[];
  }

  verifyUrl(url: string): string {
    const key = this.serviceKeys.find((k) => url.startsWith(k));
    if (!key) return url;

    const serviceBaseUrl = this.baseUrlByKey[key];
    if (!serviceBaseUrl) {
      console.warn('No base url found for key: ', key);
      return url;
    }

    return serviceBaseUrl + url.slice(key.length);
  }
}
